<template>
  <div>
    <p class="text-sm mb-4">Détail des coûts du devis</p>
    <ClaimCostItemsEditor
      v-model:editing="editing"
      :costs="quotation.costs"
      :editable="editable"
      :saving="saving"
      @save="save"
    />
    <div class="mt-4 flex items-center text-sm">
      <span class="sm">Etat du produit :</span>
      <span class="ml-3">{{ quotation.productState }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ClaimCostItemsEditor from "@/components/claim/details/ClaimCostItemsEditor.vue";

export default {
  props: ["quotation"],

  components: {
    ClaimCostItemsEditor,
  },

  emits: ["updated"],

  data() {
    return {
      editing: false,
      saving: false,
    };
  },

  computed: {
    editable() {
      return this.quotation.approvalStatus === "to_be_approved";
    },
  },

  methods: {
    ...mapActions("claims", ["updateQuotationCostItems"]),

    async save(costItems) {
      this.saving = true;
      const response = await this.updateQuotationCostItems({ quotationId: this.quotation.id, costItems });
      this.saving = false;

      if (!response?.success) return;

      this.editing = false;
      this.$emit("updated");
    },
  },
};
</script>
